import { Component, OnInit, TemplateRef, Input } from '@angular/core';
import { Router} from '@angular/router';
import { OfferService } from '../../../shared/providers/offer.service';
import { ValidationService } from '../../../shared/providers/validation.service';
import { ILeadOffersOutputModel } from '../../../shared/models/LeadOffersOutputModel';

@Component({
    selector: 'app-offer-detail-tab',
    templateUrl: './offer-detail-tab.component.html'
})
export class OfferDetailTabComponent implements OnInit {

 
    LeadOffersList: ILeadOffersOutputModel[];

    @Input() inputOfferGuid: string = "";

    constructor(private offerService: OfferService, public Validation: ValidationService, private Router: Router) { }
    offerGuid = '';

    ngOnInit() {

        this.offerGuid = this.inputOfferGuid;
        if (this.offerGuid != null) {
            this.offerService.getLeadOffers(this.offerGuid).subscribe(response => {
                
                this.LeadOffersList = response;
                this.LeadOffersList.forEach(item => {
                    item.OfferDate = this.Validation.convertUTCDateToLocalDate(item.OfferDate);
                });
            });
        }
    }


    accordion1 = "accordion-outer open margin-bottom-30";
    accordion2 = "accordion-outer open margin-bottom-30";
    toggleClass(type) {

        if (type === 1) {
            if (this.accordion1 === "accordion-outer open margin-bottom-30") {
                this.accordion1 = "accordion-outer margin-bottom-30";
            }
            else {
                this.accordion1 = "accordion-outer open margin-bottom-30";
            }
        }
        else if (type === 2) {
            if (this.accordion2 === "accordion-outer open margin-bottom-30") {
                this.accordion2 = "accordion-outer margin-bottom-30";
            }
            else {
                this.accordion2 = "accordion-outer open margin-bottom-30";
            }

        }
    }

}

